import Vue from 'vue';

const success = (context, response) => {
  context.rentalEvents = response.data.events;
};

const failed = (context, error) => {
  toastr.error("Rental not found");
};

export default (context, rental_id) => {
  return Vue.$http.get('rental/events/'+rental_id)
          .then(response => {
              if(response && response.status === 200) {
                success(context, response);
              }
           }).catch(error => {
              failed(context, error);
         });
};



// WEBPACK FOOTER //
// ./src/app/services/rental/getRentalEvents.js